<template>
  <div v-if="donation" class="donation-card" @click="onClick">
    <div class="card-content">
      <div class="image-container">
        <img :src="formattedActivity.icon" :style="{ height: '3rem' }" />
      </div>
      <div>
        <h4 v-translate>Recurring Donation</h4>
        <div v-if="formattedActivity.isSubscriptionActive">
          <span v-translate>
            Status: Active
          </span>
          <br />
          <span v-translate>
            Last Charge:
          </span>
          <br />
          <span>
            {{ `$${formattedActivity.amount}` }}
          </span>
          <br />
          <span>{{ this.donation.mostRecentRecurringDate | formatDateShort(language) }}</span>
        </div>
        <div v-else>
          <span v-translate>Status: Canceled</span>
        </div>
      </div>
    </div>

    <font-awesome-icon
      class="arrow"
      :icon="['fa', 'chevron-right']"
      :style="{ fontSize: '25px' }"
      v-if="!selected"
    />
    <div v-if="selected" :style="{ width: '30px', alignSelf: 'center' }">
      <!-- class small-load-spinner is used to adjust the size of the loadspinner to fit the ActivityCard  -->
      <LoadSpinner class="small-load-spinner" />
    </div>
  </div>
</template>

<script>
import LoadSpinner from '@/components/LoadSpinner'

export default {
  name: 'ActivityCard',
  components: {
    LoadSpinner,
  },
  data() {
    return {
      selected: false,
      language: this.$store.state.user ? this.$store.state.user.preferredLanguage : 'en_US',
    }
  },
  props: {
    donation: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async onClick() {
      this.selected = true
      if (this.donation.subscriptionId) {
        this.$router.push({
          name: 'DonationSummary',
          params: { subscriptionId: this.donation.subscriptionId },
        })
      } else {
        this.$router.push({
          name: 'DonationSummary',
          params: { id: this.donation.id },
        })
      }
      this.selected = false
    },
  },
  computed: {
    formattedActivity() {
      let icon = require('@/assets/icons/donate.png')
      return Object.assign(this.donation, { icon: icon })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

h4 {
  margin: 0 0 0.5rem 0;
}
p {
  font-family: 'Poppins-Medium';
}
.unread-messages-icon {
  position: absolute;
  left: 1.4rem;
  margin-top: -2.5rem;
}
.donation-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 2rem;
  border-radius: 9px;
  margin: 1rem 0;
  box-sizing: border-box;
  background-color: var(--light-brand-color);
  box-shadow: 0 4px 8px 0 $mid-gray;
  cursor: pointer;
}
.image-container {
  width: 6rem;
  padding-right: 1rem;
}
.card-content {
  display: flex;
}
.arrow {
  width: 1rem;
  align-self: center;
}
.small-load-spinner {
  width: 40px;
  display: flex;
  height: 40px;
}
</style>
